/* eslint-disable no-prototype-builtins */
import IntlPolyfill from "intl";

export default {
  polyfill() {
    if (
      !global.Intl ||
      (global.Intl &&
        (!Intl.hasOwnProperty("NumberFormat") ||
          !Intl.NumberFormat.prototype.hasOwnProperty("format") ||
          !Intl.NumberFormat.prototype.hasOwnProperty("formatToParts")))
    ) {
      require("intl/locale-data/jsonp/en.js");
      global.Intl = IntlPolyfill;
    }
  },
};
